import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import EventsList from './EventsList/EventsList';
import EventShow from './EventShow/EventShow';
import EventEdit from './EventEdit/EventEdit';
import EventCreate from './EventCreate/EventCreate';
import EventDelete from './EventDelete/EventDelete';

const Events = ({ match }) => {
    return (
        <div className="Events">
            <ContainerWrapper container="events">
                <Route exact path={ `${ match.url }/:type` } component={EventsList} />
                <Route exact path={ `${ match.url }/:type/new` } component={EventCreate} />
                <Route exact path={ `${ match.url }/:type/show/:eventId` } component={EventShow} />
                <Route exact path={ `${ match.url }/:type/edit/:eventId` } component={EventEdit} />
                <Route exact path={ `${ match.url }/:type/delete/:eventId` } component={EventDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default Events;
